module.exports = __webpack_public_path__ + "zilla-slab-latin-400italic.0b291f4aa56e58d9621bec965b4861e6.woff2";